import { Spacing, blue, neutral } from '@alphorm/ui'

export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: neutral[0],
    margin: ({ margin }) => margin || 0
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    padding: ({ open }) => open ? Spacing(5, 5, 2, 5) : Spacing(5),
    minHeight: 60
  },
  iconClass: {
    lineHeight: 0,
    fontSize: 10,
    transform: ({ open }) => open ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'all 0.1s linear',
    color: blue[0]
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.15s ease-out',
    overflow: 'hidden'
  },
  content: {
    padding: () => Spacing(0, 5, 5, 5)
  }
}
